import { Constants } from "../../constants";

// Action Types
export const USER_ACTION_TYPES = {
  SET_USER: 'SET_USER',
  UPDATE_USER: 'UPDATE_USER',
  CLEAR_USER: 'CLEAR_USER',
};

// Initial State
const initialState = {
  id: null,
  name: '',
  email: '',
  roleName: '',
  imagePath: null,
  companyId: 0,
  isAuthenticated: false,
  timeToLogout: Constants.SESSION_TIMEOUT / 1000 / 60,
  refreshTokenWarningAction: 'REFRESH'
};


const formatUserData = (userData) => {
  if (!userData.name) {
    userData.name = userData.firstName + ' ' + userData.lastName;
  }
  userData.imagePath = (userData.imagePath) ? `data:image/png;base64,${userData.imagePath?.split(',')[1] || userData.imagePath}` : userData.imagePath;
  userData.roleName = userData.roleName || 'Super Admin';
  return userData;
};

// Reducer
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_ACTION_TYPES.SET_USER:
      return formatUserData({
        ...action.payload,
        isAuthenticated: true,
        timeToLogout: action.payload.timeToLogout || initialState.timeToLogout,
        refreshTokenWarningAction: action.payload.refreshTokenWarningAction || initialState.refreshTokenWarningAction,
        companyId: action.payload.companyId || initialState.companyId,
      });

    case USER_ACTION_TYPES.UPDATE_USER:
      return formatUserData({
        ...state,
        ...action.payload,
      });

    case USER_ACTION_TYPES.CLEAR_USER:
      return {
        ...initialState,
        timeToLogout: 0,
      };

    default:
      return state;
  }
};

export default userReducer;
